import { TFetchOffersResult } from './types';
import { ResponseError } from '../../errors/responseError';
import { prepareOffers } from '../../mappers/prepareOffers';
import {
  fetchSearchOffersMobileSite,
  ISearchOffersMobileSiteRequest,
  TSearchOffersMobileSiteResponse,
} from '../../repositories/search-engine/v2/search-offers-mobile-site';
import { IApplicationContext } from '../../types/application';
import { isSearchOffersExperimentEnabled } from '../../utils/searchOffersExperiment';

export async function fetchOffers(
  context: IApplicationContext,
  parameters: ISearchOffersMobileSiteRequest,
): Promise<TFetchOffersResult> {
  const { httpApi } = context;

  if (!isSearchOffersExperimentEnabled(context)) {
    return {
      status: 'succeed',
      offers: [],
    };
  }

  try {
    const offersResponse: TSearchOffersMobileSiteResponse = await fetchSearchOffersMobileSite({
      httpApi,
      parameters,
    });

    if (offersResponse.statusCode !== 200) {
      throw new ResponseError({
        domain: 'shared.services.fetchOffers',
        message: offersResponse.response.message || '',
        details: {
          error: offersResponse.response.errors as any,
        },
      });
    }

    return {
      status: 'succeed',
      offers: prepareOffers(offersResponse.response),
    };
  } catch (ex) {
    const { logger } = context;

    logger.error(ex);

    return {
      status: 'failed',
      offers: [],
    };
  }
}
